import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./UserMarkerInfoWindow.module.scss";
export const UserMarkerInfoWindow = () => {
    const { __ } = useTranslations();
    return (_jsx("div", { className: styles.infoWindowContentWrapper, children: _jsx("span", { className: styles.infoWindowText, children: __("storelocator.user_location.infowindow.label") }) }));
};
//# sourceMappingURL=UserMarkerInfoWindow.js.map